// extracted by mini-css-extract-plugin
module.exports = {"MovieList":"MovieList_MovieList__33XAP"};